<template>
  <span class="badge" :class="roleClass">{{ role.name }}</span>
</template>

<script>
import config from '../../constants/config';

export default {
  name: "RoleTag",
  props: {
    role: Object
  },
  computed: {
    roleClass() {
      return {
        'badge-outline-light': this.role.id === config.PARTNER,
        'badge-outline-info': this.role.id === config.MANAGER,
        'badge-outline-primary': this.role.id === config.MEMBER,
        'badge-outline-primary': this.role.id === config.MACHINE,
        'badge-outline-secondary': this.role.id === config.STAFF_USER,
        'badge-outline-dark': this.role.id === config.SUPERUSER
      };
    }
  }
};
</script>
